(function () {
    'use strict';

    /*
     * Copyright (c) 2017 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .controller('CampaignMessagesCtrl', CampaignMessagesCtrl);

    CampaignMessagesCtrl.$inject = ['$routeParams', 'RestResources', 'IhhMedia', 'CampaignMessagesConstants',
        '_', 'EpisodeTemplateService', 'IhhModalItemChooser'];

    function CampaignMessagesCtrl ($routeParams, RestResources, IhhMedia, CampaignMessagesConstants,
        _, EpisodeTemplateService, IhhModalItemChooser) {
        var vm = this;
        var campaignId = $routeParams.campaignId;
        var episodeTemplateId = vm.episodeModel.id;
        var newMessageId;

        vm.templateStrings = CampaignMessagesConstants.templateStrings;
        vm.chooseImage = chooseImage;
        vm.chooseAudio = chooseAudio;
        vm.chooseVideo = chooseVideo;
        vm.getImageUrl = function(message, name) {
            return vm.messagesCrud.getMessageImageUrl(campaignId, episodeTemplateId, message.id, name);
        };
        vm.getAudioUrl = function(message, name) {
            return vm.messagesCrud.getMessageAudioUrl(campaignId, episodeTemplateId, message.id, name);
        };
        // These arguments are reversed from above because of how view-edit-media works
        vm.getVideoUrl = function(name, message) {
            return vm.messagesCrud.getMessageVideoUrl(campaignId, episodeTemplateId, message.id, name);
        };
        vm.removeMedia = removeMedia;
        vm.sendMessage = sendMessage;
        vm.messageHasContent = messageHasContent;
        vm.getDefaultPersonThumbnailUrl = getDefaultPersonThumbnailUrl;
        vm.newMessage;
        vm.messages;
        vm.removeMessage = removeMessage;

        vm.changeAuthor = changeAuthor;

        activate();

        function activate () {
            retrieveData();
        }

        function retrieveData () {
            displayBusyIndicator();

            vm.messagesCrud.query(campaignId, episodeTemplateId).then(function (result) {
                vm.messages = result.items;
            }, function (err) {
                RestResources.reportRestError(CampaignMessagesConstants.query.errorString, err);
            }).finally(function () {
                hideBusyIndicator();
            });

            RestResources.getNewObjectResource().save({}, function (result) {
                vm.newMessage = result;
                newMessageId = vm.newMessage.id;
            });
        }

        function reset () {
            retrieveData();
        }

        function getDefaultPersonThumbnailUrl () {
            return RestResources.getDefaultPersonThumbnailUrl();
        }

        function chooseImage () {
            var mediaResource = vm.messagesCrud.getMessageMediaResource(campaignId, episodeTemplateId, newMessageId);
            chooseNewMedia(mediaResource, CampaignMessagesConstants.types.image);
        }

        function chooseAudio () {
            var mediaResource = vm.messagesCrud.getMessageMediaResource(campaignId, episodeTemplateId, newMessageId);
            chooseNewMedia(mediaResource, CampaignMessagesConstants.types.audio);
        }

        function chooseVideo () {
            var mediaResource = vm.messagesCrud.getMessageMediaResource(campaignId, episodeTemplateId, newMessageId);
            chooseNewMedia(mediaResource, CampaignMessagesConstants.types.video);
        }

        // uses a promise to display the busy indicator
        function displayBusyIndicator () {
            EpisodeTemplateService.displayBusyIndicator();
        }

        // clears the promise so that the busy indicator will no longer be displayed
        function hideBusyIndicator () {
            EpisodeTemplateService.hideBusyIndicator();
        }

        function sendMessage () {
            displayBusyIndicator();

            if (vm.therapistId) {
                vm.newMessage.sender = {
                    id: vm.therapistId
                };
            }
            vm.messagesCrud.save(campaignId, episodeTemplateId, vm.newMessage).then(function () {
                reset();
            }, function (err) {
                RestResources.reportRestError(CampaignMessagesConstants.save.errorString, err);
            }).finally(function() {
                hideBusyIndicator();
            });
        }

        function removeMessage (episodeTemplateMessageId) {
            displayBusyIndicator();

            vm.messagesCrud.remove(campaignId, episodeTemplateId, episodeTemplateMessageId).then(function () {
                reset();
            }, function (err) {
                RestResources.reportRestError(CampaignMessagesConstants.remove.errorString, err);
            }).finally(function() {
                hideBusyIndicator();
            });
        }

        /**
        * This function calls the respective ihhMedia chooseMedia functions. See documentation of these functions
        * for information about accepted parameters. Here we utitlize the uploadFn parameter (last param)
        * to define the $promise used by cgBusy. This is executed prior to the beginning of the
        * upload and will trigger the initialization of the wait indicator. We resolve this promise
        * when the message has finished uploading.
        *
        * @param {object} mediaResource - the media resource
        * @param {object} type - the type of the media
        */
        function chooseNewMedia (mediaResource, type) {
            var successFn = function(name) {
                vm.newMessage[type.key] = vm.newMessage[type.key] || [];
                vm.newMessage[type.key].push(name);


                if (vm.therapistId) {
                    vm.newMessage.sender = {
                        id: vm.therapistId
                    };
                }
                vm.messagesCrud.save(campaignId, episodeTemplateId, vm.newMessage).then(function () {
                    reset();
                }, function (err) {
                    RestResources.reportRestError(type.errorText, err);
                }).finally(function() {
                    hideBusyIndicator();
                });
            };

            var failureFn = function(err) {
                RestResources.reportRestError(type.errorText, err);
                hideBusyIndicator();
            };

            if (CampaignMessagesConstants.types.image.key === type.key) {
                IhhMedia.chooseImage(mediaResource, type.title, type.message, successFn, failureFn, displayBusyIndicator);
            }
            else if (CampaignMessagesConstants.types.audio.key === type.key) {
                IhhMedia.chooseAudio(mediaResource, type.title, type.message, successFn, failureFn, displayBusyIndicator);
            }
            else if (CampaignMessagesConstants.types.video.key === type.key) {
                IhhMedia.chooseVideo(mediaResource, type.title, type.message, successFn, failureFn, displayBusyIndicator);
            }
        }

        function removeMedia () {
            delete vm.newMessage.images;
            delete vm.newMessage.audio;
            delete vm.newMessage.video;
        }

        function messageHasContent () {
            return _.has(vm.newMessage, 'message');
        }

        /**
         * If changing the author is supported, then changes the author of the message.
         *
         * @param {Object} message
         */
        function changeAuthor (message) {
            if (vm.therapistConfig) {
                vm.therapistConfig.setSelectedFn(function(item) {
                    message.sender = item;

                    vm.messagesCrud.update(campaignId, episodeTemplateId, message).then(function (result) {
                        _.assign(message, result);
                    }, function (err) {
                        RestResources.reportRestError('', err);
                    }).finally(function () {
                    });
                });

                vm.therapistConfig.setDirty(true);
                vm.therapistConfig.nextPage();
                IhhModalItemChooser.open(vm.therapistConfig);
            }
        }
    }
})();